module.exports = __webpack_public_path__ + "static/assets/2e50bcae73c66d54d6907bf78ea8442c.png";